<label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<input class="esf-form-item__field"
       [ngClass]="{'text-color-dark': !isDark, 'text-color-light': isDark}"
       autocomplete="off"
       [formControl]="formControl"
       [id]="id"
       [readOnly]="true"
       [style.background]="color"
       [(colorPicker)]="color"
       [cpOutputFormat]="'hex'"
       [cpPosition]="'bottom'"
       (colorPickerChange)="colorChanged.emit($event)">
